import { getCurrentUrlParameter } from 'utils/url';

/**
 * AVS-4405: reads the `?dealerId=` handover (AVP Portal) and removes it from the URL in one step, whatever its value.
 * The two are one step on purpose: a parameter left behind by a cancelled run belongs to the brand and market being
 * left, and must not be applied by the next run.
 * Returns the trimmed value, or undefined when the param is absent or empty. Does not validate or select it:
 * the dealer gate validates it with the same rules as a dialog choice.
 */
export function consumeDealerIdFromUrl(): string | undefined {
  const dealerIdParam = getCurrentUrlParameter('dealerId');

  // Param is entirely absent from the URL — nothing to read or strip
  if (dealerIdParam === undefined) {
    return undefined;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete('dealerId');
  window.history.replaceState(null, '', url.toString());

  // getCurrentUrlParameter JSON-parses the value, so a numeric-looking param arrives as a number
  return String(dealerIdParam).trim() || undefined;
}
